import LayerGroup from 'ol/layer/Group'
import {buildStyleFunctionFromBackend, createLayer, createLayerToViewer, createThematicLayer} from "../helpers";
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";



export async function getRegisteredLayers(module = null) {
    const route = module ? `api/maps/layers?onlyAlloweds&module=${module}&metaOnly=1` : 'api/maps/layers?onlyAlloweds&metaOnly=1';
    const response = await window.axios.get(route);
    const layersData = response.data.data;

    let layers = await Promise.all(
        layersData.map(async layer => {
            const created = await createLayer(layer);
            return created;
        })
    );

    layers = layers.flat()
    return layers.filter(item => item !== null).reverse();
}

export async function getCustomLayers() {
    const response = await window.axios.get('api/maps/thematic-layers?onlyAlloweds&metaOnly=1');
    const layersData = response.data.data || [];

    layersData.forEach(layer => {
        layer.style = buildStyleFunctionFromBackend(layer)
    })

    const layerPromises = layersData.map(createThematicLayer);
    const resolvedLayers = await Promise.all(layerPromises);
    const filteredLayers = resolvedLayers.filter(item => item !== null).reverse();

    const group = new LayerGroup({
        title: 'Multifinalitário',
        displayInLayerSwitcher: true,
        visible: false,
        layers: filteredLayers
    });

    group.set('id', 'multifuncional-group');

    // Marca as camadas como do grupo Multifinalitário (para exibir ícone de notificação no layer switcher)
    group.getLayers().getArray().forEach(ly => {
        ly.set('isMultifinalitario', true);
        ly.set('layerSwitcherGroup', 'Multifinalitário');
    });

    return group;
}

export async function getSubdivisionBuildingFeatureByCoordinate(coordinate) {
    const url = `/api/map-actions/bic/feature-by-coordinate/${coordinate}`

    try {
        let response = await window.axios.get(url)
        return  response.data.data
    } catch (error) {
        console.warn(`Erro ao buscar dados da camada`, error)
    }
}

export async function getSubdivisionBuildingFeatureByPropertyId(propertyId) {
    const url = `/api/map-actions/bic/feature-by-property-id/${propertyId}`

    try {
        let response = await window.axios.get(url)
        return  response.data.data
    } catch (error) {
        console.warn(`Erro ao buscar dados da camada`, error)
    }
}